import React from 'react'
import { initializeFormValidation } from '../../../../helpers/forms/form-validation'
import customRequest from '../../../../helpers/customRequest'
import message from '../../../../components/message/message'
import redirect from '../../../../components/redirect/redirect'
import getURLParameters from '../../../../helpers/getURLParams'
import ClipLoader from "react-spinners/ClipLoader"

class Recover extends React.Component {
    state = {
        submitting: false
    }
    componentDidMount() {
        var params = getURLParameters()
        customRequest.get('/api/account/recover', {
            params: { code: params.code }
        })
        .then(({data: response}) => {
            if (!response.valid) {
                redirect.send("/account/log-in/teacher", () => {
                    message.send("We weren't able to reset your password. Please try again.")
                })
            }
        })
        initializeFormValidation(this.onSubmit)
    }

    onSubmit = () => {
        var params = getURLParameters()
        this.setState({submitting: true}, () => {
            customRequest.put('/api/account/recover', {
                code: params.code,
                password: document.getElementById('password').value
            })
            .then(({data: response}) => {
                this.setState({submitting: false})
                if (response.valid) {
                    return redirect.send("/account/log-in/teacher", () => {
                        message.success("Your password is now changed! Please login to access your account.")
                    })
                }
                else if (response.valid == false) {
                    message.error(response.message)
                }
                else {
                    message.error("There has been a problem with your request. Please try again.")
                }
            })
        })
    }

    render() {
        if (this.props.type != null && this.props.type != "guest") {
            redirect.send('/dashboard', () => {
                message.error("You can't reset your password when logged in.")
            })
        }

        return (
            <React.Fragment>
                <h1>Reset Your Password</h1>

                <form class = "form-horizontal form-validate" novalidate method = "post">
                    <div class = "form-group row">
                        <label for = "password" class = "d-none d-sm-inline col-sm-3 control-label text-right">Password</label>
                        
                        <div class = "col-sm-6">
                            <input type = "password" class = "form-control string" disabled={this.state.submitting} id = "password" name = "password" placeholder = "Password" required data-type = "new password" minlength = "5" data-description = "enter your new password" autofocus />
                        </div>
                    </div>
                    
                    <div class = "form-group row">
                        <label for = "password-confirmation" class = "d-none d-sm-inline col-sm-3 control-label text-right">Confirm&nbsp;Password</label>
                        
                        <div class = "col-sm-6">
                            <input type = "password" class = "form-control confirmation" disabled={this.state.submitting} id = "password-confirmation" name = "password-confirmation" placeholder = "Confirm Password" required data-confirms = "password" data-description = "confirm your new password" data-type = "passwords" />
                        </div>
                    </div>
                    
                    <button type = "submit" class = "btn btn-secondary btn-lg" disabled={this.state.submitting}>{this.state.submitting ?
                        <ClipLoader
                            size={20}
                            color={"#123abc"}
                            loading={this.state.submitting}
                            /> : "Reset Password"}</button>
                </form>
            </React.Fragment>
        )
    }
}

export default Recover
